/**
 * 视频宽高比 → CSS aspect-ratio 字符串。
 * 分镜首帧框/分镜结果框过去写死竖版(3/4、9/16),选 16:9 横版时图被裁/挤。
 * 统一让预览框跟随用户选的 ratio,配 object-contain 完整显示不裁。
 */
export function ratioToCss(ratio?: string | null, fallback = "3 / 4"): string {
  if (!ratio) return fallback;
  const m = ratio.match(/^\s*(\d+(?:\.\d+)?)\s*[:：/]\s*(\d+(?:\.\d+)?)\s*$/);
  if (!m) return fallback;
  const w = Number(m[1]);
  const h = Number(m[2]);
  if (!w || !h) return fallback;
  return `${w} / ${h}`;
}

/** 是否横版(宽 > 高)— 横版预览框给更大宽度,竖版收窄。 */
export function isLandscape(ratio?: string | null): boolean {
  if (!ratio) return false;
  const m = ratio.match(/^\s*(\d+(?:\.\d+)?)\s*[:：/]\s*(\d+(?:\.\d+)?)\s*$/);
  if (!m) return false;
  return Number(m[1]) > Number(m[2]);
}
